// B2B2C returns: how what was sent to the e-commerce system, and what it answered, is shown.

import { getStatusColor } from 'components/Orders/OrderStatus';
import { B2CNotificationStatus, ReturnB2CStatus, ReturnStatusType } from 'returnCenter-api';

export const getB2CStatusKey = (status?: ReturnB2CStatus | null) => {
    switch (status) {
        case ReturnB2CStatus.ManuallyHandled:
            return 'b2c.status.handled';
        case ReturnB2CStatus.Queued:
            return 'b2c.status.queued';
        case ReturnB2CStatus.Processed:
            return 'b2c.status.processed';
        case ReturnB2CStatus.Failed:
            return 'b2c.status.failed';
        case ReturnB2CStatus.PublishFailed:
            return 'b2c.status.publishFailed';
        default:
            return null;
    }
};

/** Same palette as the return statuses: refunded reads as Completed, waiting as Received, failed as CreditError. */
export const getB2CStatusColor = (status?: ReturnB2CStatus | null) => {
    switch (status) {
        case ReturnB2CStatus.Processed:
            return getStatusColor(ReturnStatusType.Completed);
        case ReturnB2CStatus.Queued:
            return getStatusColor(ReturnStatusType.Received);
        case ReturnB2CStatus.Failed:
        case ReturnB2CStatus.PublishFailed:
            return getStatusColor(ReturnStatusType.CreditError);
        default:
            return getStatusColor(null);
    }
};

/** What one e-commerce order's notification means for the return as a whole. */
export const toReturnB2CStatus = (status?: B2CNotificationStatus): ReturnB2CStatus => {
    switch (status) {
        case B2CNotificationStatus.Sent:
            return ReturnB2CStatus.Queued;
        case B2CNotificationStatus.Succeeded:
            return ReturnB2CStatus.Processed;
        case B2CNotificationStatus.Failed:
            return ReturnB2CStatus.Failed;
        default:
            return ReturnB2CStatus.PublishFailed;
    }
};
